import { useTranslation } from 'react-i18next';

import { Page } from 'components/Page';

import { config } from 'utils/config/env';

import styles from 'styles/login.module.css';

function TermsOfService() {
  const { t } = useTranslation('term-of-service');
  const brandName = config.VITE_APP_NAME;

  return (
    <Page title="Terms of Service" description="Terms of Service">
      {/* <TopNavbar /> */}
      <div className={styles.termsOfService}>
        <h2>{t('heading', { brand: brandName })}</h2>

        <div>
          <p>{t('description.intro', { brand: brandName })}</p>
          <p>{t('description.agreement', { brand: brandName })}</p>
          <p>{t('description.amendments', { brand: brandName })}</p>
          <p>{t('description.lastUpdated')}</p>
        </div>

        <h3>{t('limitationsOfUse.title')}</h3>
        <p>{t('limitationsOfUse.intro')}</p>
        <ol>
          {(
            t('limitationsOfUse.items', { returnObjects: true }) as string[]
          ).map((item: string, index: number) => (
            <li key={index}>{item}</li>
          ))}
        </ol>

        <h3>{t('intellectualProperty.title')}</h3>
        <p>{t('intellectualProperty.paragraph1', { brand: brandName })}</p>
        <p>{t('intellectualProperty.paragraph2', { brand: brandName })}</p>

        <h3>{t('liability.title')}</h3>
        <p>{t('liability.paragraph1', { brand: brandName })}</p>
        <p>{t('liability.paragraph2', { brand: brandName })}</p>
        <p>{t('liability.paragraph3')}</p>
        <p>{t('liability.paragraph4')}</p>

        <h3>{t('accuracyOfMaterials.title')}</h3>
        <p>{t('accuracyOfMaterials.content', { brand: brandName })}</p>

        <h3>{t('links.title')}</h3>
        <p>{t('links.content', { brand: brandName })}</p>

        <h3>{t('rightToTerminate.title')}</h3>
        <p>{t('rightToTerminate.content')}</p>

        <h3>{t('severance.title')}</h3>
        <p>{t('severance.content')}</p>

        <h3>{t('governingLaw.title')}</h3>
        <p>{t('governingLaw.content')}</p>
      </div>
    </Page>
  );
}

export { TermsOfService };
